import SurveyEditStore from "../stores/SurveyEditStore";
import { useStore } from "effector-react";

import { Droppable, Draggable } from "react-beautiful-dnd";

import DisqualificationBox from "./Disqualifications/DisqualificationBox";
import NewDisqualificationBox from "./Disqualifications/NewDisqualificationBox";

import { useState } from "react";

function DisqualificationList(props: { survey: string }) {
    const survey_edit = useStore(SurveyEditStore);
    const [isAdding, isAddingSet] = useState(false);

    return (
        <>
            <div className="mb-40">
                <Droppable droppableId="disqualificationList">
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {survey_edit[`${props.survey}Survey`]?.disqualifications?.map((dq, index) => (
                                <Draggable key={dq?.id} draggableId={`Disqualification#${dq?.id}}`} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <DisqualificationBox key={index} dq={dq} survey={props.survey} />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                {isAdding && <NewDisqualificationBox closeCallback={isAddingSet} survey={props.survey} />}

                {!isAdding && (
                    <button
                        type="button"
                        className="m-6 p-6 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        onClick={() => isAddingSet(!isAdding)}
                    >
                        ADD NEW
                    </button>
                )}
            </div>
        </>
    );
}
export default DisqualificationList;
